import { z } from 'zod';
/**
 * Код персонажа (D29): по нему мастер подберёт драфт.
 *
 * Не uuid: код диктуют голосом за столом. Отсюда два требования,
 * которые и определили и алфавит, и длину.
 *
 * **Алфавит — Crockford Base32**: цифры и заглавные латинские буквы
 * без `I`, `L`, `O` и `U`. Первые три выброшены потому, что
 * на слух и на глаз не отличаются от `1`, `1` и `0`; `U` — потому
 * что без неё из кода не собирается ни одно бранное слово.
 * Тридцать два знака — пять бит на знак ровно, поэтому случайный
 * байт раскладывается в код без смещения: 256 делится на 32 нацело.
 *
 * **Длина — десять знаков**, то есть пятьдесят бит. Считаем оба риска
 * для десяти тысяч персонажей — это партий на две тысячи, то есть
 * заведомо больше, чем проект увидит:
 *
 * - *столкновение*. Всего кодов 32¹⁰ ≈ 1.13·10¹⁵. Вероятность, что
 *   среди десяти тысяч найдутся два одинаковых, — 1 − e^(−n(n−1)/2N)
 *   ≈ 4.4·10⁻⁸. Раз в двадцать миллионов таких проектов;
 * - *подбор*. Слепая попытка попадает в существующий код
 *   с вероятностью 10⁴/1.13·10¹⁵ ≈ 8.9·10⁻¹². Миллион попыток
 *   в секунду круглый год дают 0.28 попадания.
 *
 * Восьми знаков хватило бы против столкновений (4.5·10⁻⁵), но не
 * против подбора: те же миллион попыток в секунду за год нашли бы
 * около трёхсот тысяч чужих персонажей. Поэтому десять, а не восемь;
 * двенадцать уже плохо диктуются.
 */
export const CHARACTER_CODE_ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
export const CHARACTER_CODE_LENGTH = 10;
export const characterCodeSchema = z
    .string()
    .regex(new RegExp(`^[${CHARACTER_CODE_ALPHABET}]{${CHARACTER_CODE_LENGTH}}$`), `ожидается код из ${CHARACTER_CODE_LENGTH} знаков без похожих друг на друга букв`);
/**
 * Код, продиктованный человеком, — к каноническому виду.
 *
 * Ввод правится, а не отвергается: разделители и регистр к коду
 * отношения не имеют, а `O`, `I` и `L` человек напишет вместо `0`
 * и `1` независимо от того, что мы про них решили. Это то самое
 * послабление при чтении, ради которого алфавит Crockford
 * и придуман: строго пишем, мягко читаем.
 */
export function normalizeCharacterCode(input) {
    return input
        .toUpperCase()
        .replace(/O/g, '0')
        .replace(/[IL]/g, '1')
        .replace(/[^0-9A-Z]/g, '');
}
//# sourceMappingURL=code.js.map